// here is where the API data is consumed then reformed into a usable object for component consumption

import ScenariosAPI from "../api/GetScenarios";

class ScenariosObject {
  constructor(scenariosData) {
    this.scenariosData = scenariosData;
    return this.createScenariosObject();
  }

  createScenariosObject() {
    let scenarioObj = {};

    scenarioObj["scenarios"] = this.scenariosData.reduce((ob, val) => {
      ob[val.title_slug] = this.buildScenarioData(val);
      return ob;
    }, {});
    scenarioObj["scenariosOrder"] = this.buildOrderArray(this.scenariosData);

    return scenarioObj;
  }

  buildScenarioData(scenario) {
    const data = {
      title: scenario.title,
      title_slug: scenario.title_slug,
      description: scenario.description,
      sortNumber: scenario.sort_field,
      strategies: scenario.strategies.reduce((arr, val) => {
        arr.push(val.Strategy);
        return arr;
      }, [])
    };

    if (scenario.scenario_image) {
      data["imgRect"] = {
        name: scenario.scenario_image.title,
        filename: scenario.scenario_image.filename,
        url: scenario.scenario_image.data.full_url
      };
    }

    if (scenario.scenario_image_grid) {
      data["imgSquare"] = {
        name: scenario.scenario_image_grid.title,
        filename: scenario.scenario_image_grid.filename,
        url: scenario.scenario_image_grid.data.full_url
      };
    }

    return data;
  }

  buildOrderArray(data) {
    let dataArray = [];

    data.forEach(item => {
      dataArray.push({ name: item.title_slug, sortValue: item.sort_field });
    });

    return dataArray
      .sort((a, b) => a.sortValue - b.sortValue)
      .map(item => item.name);
  }
}

export default async function() {
  const getScenarios = await ScenariosAPI();
  return new ScenariosObject(getScenarios);
}
